module.exports = __webpack_public_path__ + "static/img/advantage2.87ba4a88.png";